<template>
  <div class="box">
    <g-swiper :images="topImages"></g-swiper>
    <member-com fromPage="mine"></member-com>
    <div :style="{ 'margin-top': '-70rpx' }">
      <!-- 6个box -->
      <div class="m-30">
        <div class="item_box f-bt">
          <div class="c-fc-center bg-white c-p-35 b-r-16 c-ft-26 w-32% b-s base_item" @click="handleToPage('PointMall')">
            <img
              src="@/assets/images/mine-points.png"
              class="c-w-60 c-m-b-15"
            ></img>
            <p>积分商城</p>

          </div>
          <div class="c-fc-center bg-white c-p-35 b-r-16 c-ft-26 w-32% b-s base_item no_open_con" @click="$toast('暂未开放敬请期待')">
            
            <img
              src="@/assets/images/mine-wechat.png"
              class="c-w-60 c-m-b-15"
            ></img>
            <p>微信支付</p>
          </div>
          
          <div class="c-fc-center bg-white c-p-35 b-r-16 c-ft-26 w-32% b-s base_item" @click="handleToPage('MyCouponList')">
            <van-badge :content="couponCount" max="99">
  <div class="c-fc-center">
    <img
              src="@/assets/images/mine-my-coupon.png"
              class="c-w-60 c-m-b-15"
            ></img>
            <p>我的票券</p>
  </div>
</van-badge>
            
          </div>
        </div>

        <div class="f-bt c-m-t-15">
          <div class="c-fc-center bg-white c-p-35 b-r-16 c-ft-26 w-32% b-s base_item" @click="handleToPage('MyMemberCard')">
           
            <img
              src="@/assets/images/mine-vip.png"
              class="c-w-60 c-m-b-15"
            ></img>
            <p>会员卡支付</p>
          </div>
          <div class="c-fc-center bg-white c-p-35 b-r-16 c-ft-26 w-32% b-s base_item" @click="handleToPage('HandleEleCard')">
            
            <img
              src="@/assets/images/mine-member-bind.png"
              class="c-w-60 c-m-b-15"
            ></img>
            <p>会员卡办理</p>
          </div>
          <div class="c-fc-center bg-white c-p-35 b-r-16 c-ft-26 w-32% b-s base_item" @click="handleToPage('BindRealCard')">
            
            <img
              src="@/assets/images/mine-card-bind.png"
              class="c-w-60 c-m-b-15"
            ></img>
            <p>实体卡绑定</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import memberCom from "@/newViews/homePage/comps/memberCom";
import {getMyTicketCount} from '@/api/coupon'
export default {
  name: "PersonCenter",
  props: {},
  data() {
    return {
      couponCount: 0,
      topImages: [
        "http://images01.wechat.goldenyun.cn/102071/36eac7e6-1693-478c-8809-45e874be465e/637703240602991143.jpg",
        "http://images02.wechat.goldenyun.cn/102071/36eac7e6-1693-478c-8809-45e874be465e/637703244666744226.jpg",
      ],
    };
  },
  components: {
    memberCom,
  },
  created() {},
   watch: {
    "$store.state.vpnId"(val) {
      
       this.handleGetCouponCount()

    },
  },
  mounted() {
    if( this.$store.state.vpnId){
    this.handleGetCouponCount()

    }
  },
  methods: {
    handleToPage(name) {
      this.$router.push({
        name: name,
      });
    },
    handleGetCouponCount(){
getMyTicketCount({vpnId:this.$store.state.vpnId }).then(res=>{
  this.couponCount=res.AvalibleTicketTotal
})
    },
  },
};
</script>
<style scoped lang="scss">
.base_item{
  box-shadow: 0px 20px 40px 0px rgba(213, 213, 213, 0.5);
}
.no_open_con {
  background: #f7f7f7!important;
}
</style>
